import React from 'react'
import Seo from "../components/seo"
import Layout from "../components/layout"
import { SeminarArea } from "../components/seminar-area"
import { Report } from "../components/note/report"
import { LatestSeminar } from "../components/latest-seminar"
import PickupIssue from "../components/top/content-after-video"

import { Link, graphql } from 'gatsby'
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"
import { selectByRandom } from "../functions/select-by-random"
import SpHeaderBorderObserver from '../functions/sp-header-border-observer'
import { convertTimeToAziaZone } from '../functions/convert-time-to-azia-timezone'
import "../styles/pc/top.scss"
import "../styles/sp/top.scss"

export default function TopPage({ data }) {

	return (
    <Layout isSeminar={true}>
      <Seo
        type="article"
        title="Top"
        description="人と組織と社会のつながりを再生し、未来へつなぐ ジェイフィールは想いをつなぐプラットフォームでありたいと考えています。"
        bobyClassName="top"
      />
      <div className="top">
        <SpHeaderBorderObserver />
        {/*//////////////////////////////* ↓ファーストビュー * //////////////////////////////*/}
        <div className="first-view">
          <div className="nowar">
            <LazyAndPreloadImage imgUrl={'/images/pc/top/ukraine.png'} alt={"ウクライナ国旗"} />
            <div className="nowar_title">
              私達はすべての人たちの平和を望みます。<br/>
              #NOWAR
            </div>
          </div>
          <div className="first-view_inner">
            <div className="fv_title">
              <span className='s_title'>
                <span className='decoration flip'>/</span>わたしたちジェイフィールは<span className='decoration'>/</span>
              </span>
              <span className='highlight'>真のエンゲージメント</span>が生まれ<br/>
              重なり合う組織づくりを応援します
            </div>
            <div className="fv_description">
              エンゲージメントとは<br className='sp_only'/>誰かが「引き出すもの」なのでしょうか<br/>
              エンゲージメントは、深い関係性と対話の中から<br className='sp_only'/>
              「生まれてくるもの」なのではないでしょうか
            </div>
          </div>
          <div className='recommend_content'>
            <div className='rc_inner'>
              <div className='rc_label'>
                <span className='label_deco'>/  PICK UP</span><br/>
                ジェイフィールのおすすめ
              </div>
              <div className='rc_flex'>
                {/* ピックアップコンテンツ① */}
                <LatestSeminar />
                {/* ピックアップコンテンツ② */}
                {data.programs.edges.filter(programs => ["16j5gyvhx7"].includes(programs.node.programsId)).map(({ node }) => (
                  <Link to={'/program/' + node.programsId} className='rc_flex_item'>
                    <div className='item_tag'>日本初の内省プログラム</div>
                    
                      <>
                        <div className='item_img'>
                          <LazyAndPreloadImage imgUrl={"/images/pc/top/img_RRT.png"} alt={"プログラム一覧"} />
                        </div>
                        <div className='item_descroption'>
                          <div className='item_title'>{node.title}</div>
                          <div className='item_subtitle'>{node.subtitle}</div>
                        </div>
                      </>
                  </Link>
                ))}
                {/* ピックアップコンテンツ③ */}
                <PickupIssue />
              </div>
            </div>
          </div>
        </div>
        {/*//////////////////////////////* ↑ファーストビュー * //////////////////////////////*/}

        {/*//////////////////////////////* ↓セミナー * //////////////////////////////*/}
        <SeminarArea />
        {/*//////////////////////////////* ↑セミナー * //////////////////////////////*/}

        {/*//////////////////////////////* ↓プログラム * //////////////////////////////*/}
        <div className='program_container'>
          <div className="inner_title">
            <div>
              <h4 className="maintitle">Program</h4>
              <p className="subtitle">組織を未来につなげるプログラム</p>
            </div>
            <div className="more"><Link to="/program"><span>view more</span></Link></div>
          </div>
          <div className="flex_wrap">
            {data.programs.edges.filter(programs => ["16j5gyvhx7", "qpnj-vzsl", "5dpeanaz2b"].includes(programs.node.programsId)).map(({ node }) => (
              <div className="flex_item" key={node.programsId}>
                <Link to={'/program/' + node.programsId}>
                  <div className='card_heading'>
                    <p className='heading_item'>
                      {
                        node.programsId === "16j5gyvhx7" ? (<>エンゲージメントが<br/>生まれる場をつくる</>) :
                        node.programsId === "qpnj-vzsl" ? (<>キャリア自律を後押し<br/>組織の創造性を高める</>) :
                        node.programsId === "5dpeanaz2b" ? (<>真のつながりをつくる<br/>次世代リーダーになる</>) :
                        ''
                      }
                    </p>
                  </div>
                  <div className="thumbnail_container">
                    <LazyAndPreloadImage imgUrl={node.thumbnail ? node.thumbnail.url : ''} alt={"プログラム一覧"} />
                  </div>
                  <div className="program_title">{node.title}</div>
                  <div className="program_detail">{node.subtitle}</div>
                </Link>
                <div className="program_tag">
                  {node.task_tags.map((task, index) => task.type[0] === "プログラムタグ" ? <a key={task.id + index}>#{task.name}</a> : '')}
                  {node.hierarchy_tags.map((task, index) => task.type[0] === "プログラムタグ" ? <a key={task.id + index}>#{task.name}</a> : '')}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/*//////////////////////////////* ↑プログラム * //////////////////////////////*/}

        {/*//////////////////////////////* ↓レポート * //////////////////////////////*/}
        <Report />
        {/*//////////////////////////////* ↑レポート * //////////////////////////////*/}

        {/*//////////////////////////////* ↓お知らせ * //////////////////////////////*/}
        { Object.keys(data.informations.edges).length ?
          <div className="info_container" id="news">
            {/* <div className="info_container"> */}
            <div className="inner_title">
              <div>
                <h4 className="maintitle">News</h4>
                <p className="subtitle">新着情報</p>
              </div>
            </div>
            <ul className='info_list'>
              {data.informations.edges.map(({ node }) => (
                <Link to={node.destination_url}>
                  <li key={node.id} className='info_list_item'>
                    <>
                      <div className='item_date'>{convertTimeToAziaZone(node.date,'YYYY.MM.DD')}</div>
                      <div className='item_title'>{node.title}</div>
                    </>
                    <div className="more pc_only"></div>
                  </li>
                </Link>
              ))}
            </ul>
            {/* </div> */}
          </div>
          : ''
        }
        {/*//////////////////////////////* ↑お知らせ * //////////////////////////////*/}

        {/*//////////////////////////////* PHILOSOPHY, COMMUNITY * //////////////////////////////*/}
        <div className="circle_container">
          <div className="bg_circle"></div>
          <div className="flex_wrap">
            <div className="philosophy_container">
              <p className="tagline">PHILOSOPHY</p>
              <h4 className="title">人と組織と社会のつながりを<br/>再生し、未来へつなぐ</h4>
              <p className="description">人と組織と社会が自然とつながっていく感覚をみんなが持てるようになり、自分の中にある想いをみんなが重ね合い、未来へ踏み出す連鎖が起きていく。ジェイフィールはそんな想いをつなぐプラットフォームでありたいと考えています。</p>
              <Link to="/philosophy"><div className="view_detail">view more</div></Link>
            </div>

            <div className="community_container">
              <p className="tagline">COMMUNITY</p>
              <h4 className="title">想いをつなぐコミュニティ</h4>
              <p className="description">社内メンバーに限らず、一緒に想いを重ねている人たちをご紹介します。多様な人たちが想いや悩みを出し合い、対話や探求を通じて、ジェイフィールと関わってくれています。</p>
              <ul className="member_list">
                { Object.keys(data.communities.edges).length ?
                  selectByRandom(data.communities.edges, 3).map(({ node }) => (
                    <Link to={'/community' + generateCommunityPath(node.person_type[0]) + node.communitiesId}>
                      <li key={node.communitiesId}>
                        <LazyAndPreloadImage imgUrl={node.list_face_image ? node.list_face_image.url : ''} alt={"コミュニティー一覧"} />
                      </li>
                    </Link>
                  ))
                  : ''
                }
              </ul>
              <Link to="/community"><div className="view_detail">view more</div></Link>
            </div>
          </div>
        </div>
        {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
      </div>
    </Layout>
	)
}

function generateCommunityPath(personType) {
    if(personType === "パートナー") {
      return "/partner/"
    }

    if(personType === "メンバー") {
      return "/member/"
    }

    if(personType === "コラボレーター") {
      return "/collaborator/"
    }
}

export const query = graphql`
query TopQuery {
  communities: allMicrocmsCommunities {
    edges {
      node {
        communitiesId
        list_face_image {
          url
        }
        person_type
        name
      }
    }
  }

  programs: allMicrocmsPrograms {
    edges {
      node {
        programsId
        title
        subtitle
        thumbnail {
          url
        }
        task_tags {
          id
          name
          type
        }
        hierarchy_tags {
          id
          name
          type
        }
      }
    }
  }

  informations: allMicrocmsInformations(
    limit: 5,
    sort: {fields: [publishedAt], order: DESC}
  ) {
    edges {
      node {
        id
        title
        destination_url
        date: publishedAt
      }
    }
  }
}`
